import React, { useEffect, useState } from 'react';
import './PWAInstallPrompt.css';

const isMobile = () =>
  /android|iphone|ipad|ipod|opera mini|iemobile|mobile/i.test(navigator.userAgent);

const PWAInstallPrompt: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
      if (isMobile()) setShowPrompt(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setShowPrompt(false);
      }
    }
  };

  if (!showPrompt) return null;

  return (
    <div className="pwa-install-banner">
      <div className="pwa-install-content">
        <span>Install this app for a better mobile experience!</span>
        <button className="button button--flex" onClick={handleInstall}>
          Install
        </button>
        <button className="button button--outline" onClick={() => setShowPrompt(false)}>
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt; 